"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const linkInline_1 = __importDefault(require("../../components/linkInline/linkInline"));
const utils_1 = require("../../utils/utils");
const constants_1 = require("../../constants/constants");
const newBox_1 = __importDefault(require("../../components/box/newBox"));
const applyImg = require('../../assets/images/Doc-Lendigo.png');
const LoanHistory = ({ loanHistory }) => loanHistory.length > 0 ? (react_1.default.createElement(react_native_1.View, null, loanHistory.map((row) => {
    return (react_1.default.createElement(linkInline_1.default, { key: row.id, id: row.id, iconName: "faInfo", title: `${constants_1.NAIRA_SYMBOL}${(0, utils_1.formatNumber)(row.amount)} ${row.status} ${row.date !== null ? `on ${row.date}` : ''}`, eventName: "" }));
}))) : (react_1.default.createElement(newBox_1.default, { btn: false, srcImg: applyImg, action: () => { }, title: "No loan history", textArea: "", display: true }));
exports.default = LoanHistory;
